import { Box, Button, FormControl, FormLabel, HStack, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure, useRadio, useRadioGroup } from '@chakra-ui/react';

import { AddIcon } from '@chakra-ui/icons';
import { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectDatepicker } from 'react-select-datepicker';

export default function AddChildren({ handleMinor }) {
    const { t } = useTranslation();
    const { isOpen, onOpen, onClose } = useDisclosure();

    const initialRef = useRef(null);
    const finalRef = useRef(null);

    const [name, setName] = useState('');
    const [birthDate, setBirthDate] = useState('');

    const [gender, setGender] = useState('');

    const onOk = () => {
        onClose();
        setBirthDate('');
        setName('');
        setGender('');

        if (typeof handleMinor === 'function') {
            handleMinor({
                name,
                birthDate,
                gender,
            });
        }
    };

    const [value, setValue] = useState(null);

    const onDateChange = useCallback((date) => {
        setValue(date);

        const dateValue = new Date(date);
        const year = dateValue.getFullYear();
        const month = String(dateValue.getMonth() + 1).padStart(2, '0'); // `getMonth()` menghasilkan bulan dari 0-11
        const day = String(dateValue.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        setBirthDate(formattedDate);
    }, []);

    let today = new Date();

    // Kurangi 18 tahun
    let eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(today.getFullYear() - 18);

    // Format menjadi 'YYYY-MM-DD'
    let dateMin = eighteenYearsAgo.toISOString().split('T')[0];
    const minDate = new Date(dateMin);

    return (
        <>
            <Box my={4}>
                <Button leftIcon={<AddIcon />} colorScheme='teal' size='lg' fontSize='sm' fontWeight={700} onClick={onOpen} width='100%' variant='outline'>
                    {t('add_kids')}
                </Button>
            </Box>

            <Modal initialFocusRef={initialRef} finalFocusRef={finalRef} isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{t('add_kids_title')}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        <FormControl>
                            <FormLabel>{t('children_name')}</FormLabel>
                            <Input ref={initialRef} placeholder='Nama' onChange={(e) => setName(e?.target.value)} value={name} />
                        </FormControl>

                        <FormControl mt={4}>
                            <FormLabel>{t('birth_date')}</FormLabel>
                            <SelectDatepicker onDateChange={onDateChange} selectedDate={value} minDate={minDate} />
                        </FormControl>
                        <FormControl mt={4}>
                            <FormLabel>{t('gender')}</FormLabel>
                            <RadioGender onChange={(e) => setGender(e)} />
                        </FormControl>
                    </ModalBody>

                    <ModalFooter gap={3}>
                        <Button size='lg' variant='outline' fontSize='sm' px={8} rounded='lg' onClick={onClose}>
                            {t('cancel')}
                        </Button>
                        <Button size='lg' fontSize='sm' px={8} rounded='lg' isDisabled={value == '' || name == '' || gender == ''} colorScheme='green' mr={3} onClick={onOk}>
                            {t('save')}
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
}

// 1. Create a component that consumes the `useRadio` hook
function RadioCard(props) {
    const { getInputProps, getRadioProps } = useRadio(props);

    const input = getInputProps();
    const checkbox = getRadioProps();

    return (
        <Box as='label'>
            <input {...input} />
            <Box
                {...checkbox}
                cursor='pointer'
                borderWidth='1px'
                borderRadius='md'
                boxShadow='md'
                _checked={{
                    bg: 'teal.600',
                    color: 'white',
                    borderColor: 'teal.600',
                }}
                _focus={{
                    boxShadow: 'outline',
                }}
                px={5}
                py={3}>
                {props.children}
            </Box>
        </Box>
    );
}

// Step 2: Use the `useRadioGroup` hook to control a group of custom radios.
// eslint-disable-next-line react/prop-types
function RadioGender({ onChange }) {
    const options = ['male', 'female'];

    const { getRootProps, getRadioProps } = useRadioGroup({
        name: 'framework',
        defaultValue: '',
        onChange: onChange,
    });

    const group = getRootProps();

    return (
        <HStack {...group}>
            {options.map((value) => {
                const radio = getRadioProps({ value });
                return (
                    <RadioCard key={value} {...radio}>
                        {value}
                    </RadioCard>
                );
            })}
        </HStack>
    );
}
